import { IPoint, ISegregation, PositionSide } from './prisma-xs.model';

export interface IUprightOnGrid {
  dimensions: IUprightDimensions;
  placePosition: IPoint;
  obstructedPoints: IPoint[];
  orientation: UprightOrientation;
  positionSide: PositionSide;
}

export interface IUprightsSegregationDTO {
  uprights: IUprightOnGrid[];
  segregation: ISegregation[];
}

export interface IUprightDimensions {
  width?: number;
  height?: number;
}

export interface IUpright {
  dimensions: IUprightDimensions;
  placePosition: IPoint;
  obstructedPoints: IPoint[];
  orientation: UprightOrientation;
}

export enum UprightOrientation {
  HORIZONTAL = 0,
  VERTICAL = 1
}

export interface IUprightWidget {
  heightInRows: number;
  placePosition: IPoint;
  isBetweenKitsBorders: boolean;
  horizontalUprightsSeparators: IUprightsSeparator[];
}

export interface IUprightsSeparator {
  position: IPoint;
  width: number;
  positionSide: PositionSide;
}

export interface IGroupedPointsSeparators {
  point: number;
  separators: IUprightOnGrid[]
}
